<template>
  <div v-if="!nalaganjePridobljenihPravic" v-loading="nalaganjePridobljenihPravic">
    <div class="odmik-zgoraj-dodeljene-pravice" v-if="dodeljeneAktivnePravice.length > 0 ||
          dodeljenePraviceVpostopku.length > 0 || dodeljenePraviceNeaktivne.length > 0">
      <div>
        <p>
          Spodaj si lahko ogledate seznam pravic, ki ste jih dodelili drugim uporabnikom za pregled ali
          urejanje svoje naročnine in priključkov.
        </p>
      </div>
      <div v-if="dodeljeneAktivnePravice.length > 0">
        <div style="padding-top: 20px; padding-bottom: 20px">
          <div>
            <p class="open-sans-20pt">
              Seznam dodeljenih pravic
            </p>
          </div>
        </div>
        <div v-if="prikazTabele === '1'">
          <el-table :data="dodeljeneAktivnePravice">
            <el-table-column prop="ime" label="Uporabnik" min-width="100px">
              <template slot-scope="scope">
                <div v-for="pravica in scope.row">
                  {{ pravica.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                min-width="120px"
                prop="ime"
                label="Dodeljena pravica">
              <template slot-scope="scope">
                <div v-for="nazivPravice in scope.row.dovoljenja">
                  {{ nazivPravice.naziv }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Nabor pravice">
              <template slot-scope="scope">
                <div v-for="naborPravice in scope.row.dovoljenja">
                  {{ naborPravice.scope }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="ime"
                label="Dodeljena">
              <template slot-scope="scope">
                <div v-for="veljaOd in scope.row.dovoljenja">
                  {{ veljaOd.datumOd }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="ime"
                label="Velja do">
              <template slot-scope="scope">
                <div v-for="veljaDo in scope.row.dovoljenja">
                  <span v-if="veljaDo.datumDo === '01.01.2300 00:00:00'">
                    Do preklica
                  </span>
                  <span v-else>
                    {{ veljaDo.datumDo }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="ime" label="Status">
              <template slot-scope="scope">
                <div v-for="status in scope.row.dovoljenja">
                  Sprejeto
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="20px">
              <template slot-scope="scope">
                <div v-for="pravicaId in scope.row.dovoljenja">
                  <a style="cursor: pointer" @click="PreklicDodeljenePravice(pravicaId.id)">
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table
            :current-page='2' :page-size='1'
            :row-key="row => row.index"
            :data="dodeljeneAktivnePravice">
            <el-table-column>
              <template slot-scope="props">
                <div style="padding: 20px 0" class="open-sans-17pt" v-if="props.row.uporabnik.email !== ''">
                  <span>
                    <b>
                      Uporabnik:
                    </b>
                  </span>
                  {{ props.row.uporabnik.email }}
                </div>
                <p v-for="pravica in props.row.dovoljenja" class="mobile-cell">
                  <span>
                    <b>
                      Deljena pravica:
                    </b>
                    {{ pravica.naziv }}
                  </span>
                  <span>
                    <b>
                      Nabor pravice:
                    </b>
                    {{ pravica.scope }}
                  </span>
                  <span v-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Dodeljena:
                    </b>
                    {{ pravica.datumOd }}
                  </span>
                  <span v-else-if="typeof pravica.datumDo !== 'undefined' && pravica.datumDo !== null">
                    <b>
                      Velja od:
                    </b>
                    <span v-if="pravica.datumDo === '01.01.2300 00:00:00'">
                      Do preklica
                    </span>
                    <span v-else>
                      {{ veljaDo.datumDo }}
                    </span>
                  </span>
                  <span>
                    <b>
                      Status:
                    </b>
                    Sprejeto
                  </span>
                  <div style="padding: 0 0 20px 0;">
                    <a style="cursor: pointer; color: #111820" @click="PreklicDodeljenePravice(pravica.id)">
                      Odstrani
                      <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                    </a>
                  </div>
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="dodeljenePraviceVpostopku.length > 0">
        <div style="padding-top: 50px; padding-bottom: 20px">
          <div>
            <p class="open-sans-20pt">
              Seznam pravic na čakanju
            </p>
          </div>
        </div>
        <div v-if="prikazTabele === '1'">
          <el-table :data="dodeljenePraviceVpostopku">
            <el-table-column prop="ime" label="Uporabnik" min-width="100px">
              <template slot-scope="scope">
                <div v-for="pravica in scope.row">
                  {{ pravica.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              min-width="120px"
              prop="ime"
              label="Dodeljena pravica">
              <template slot-scope="scope">
                <div v-for="nazivPravice in scope.row.dovoljenja">
                  {{ nazivPravice.naziv }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Nabor pravice">
              <template slot-scope="scope">
                <div v-for="naborPravice in scope.row.dovoljenja">
                  {{ naborPravice.scope }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Dodeljena">
              <template slot-scope="scope">
                <div v-for="veljaOd in scope.row.dovoljenja">
                  {{ veljaOd.poslano }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Velja do">
              <template slot-scope="scope">
                <div v-for="veljaDo in scope.row.dovoljenja">
                  <span v-if="veljaDo.poteceno === '01.01.2300 00:00:00'">
                    Do preklica
                  </span>
                  <span v-else>
                    {{ veljaDo.poteceno }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Status">
              <template slot-scope="scope">
                <div v-for="status in scope.row.dovoljenja">
                  <span class="primarna-barva">
                    Na čakanju
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="20px">
              <template slot-scope="scope">
                <div v-for="pravicaId in scope.row.dovoljenja">
                  <a style="cursor: pointer" @click="PreklicPoslanegaPovabila(pravicaId.id)">
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table
            :current-page='2' :page-size='1'
            :row-key="row => row.index"
            :data="dodeljenePraviceVpostopku">
            <el-table-column>
              <template slot-scope="props">
                <div style="padding: 20px 0" class="open-sans-17pt" v-if="typeof props.row.uporabnik !== 'undefined'">
                  <div v-if="props.row.uporabnik.ime !== undefined">
                    <span>
                        <b>
                          Uporabnik:
                        </b>
                      </span>
                    {{ props.row.uporabnik.ime }}
                  </div>
                  <div>
                    <span>
                        <b>
                          Email:
                        </b>
                      </span>
                    {{ props.row.uporabnik.email }}
                  </div>
                </div>
                <p v-for="pravica in props.row.dovoljenja" class="mobile-cell">
                  <span>
                    <b>
                      Deljena pravica:
                    </b>
                    {{ pravica.naziv }}
                  </span>
                  <span>
                    <b>
                      Nabor pravice:
                    </b>
                    {{ pravica.scope }}
                  </span>
                  <span v-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Dodeljena:
                    </b>
                    {{ pravica.scope }}
                  </span>
                  <span v-else-if="typeof pravica.sprejeto !== 'undefined' && pravica.sprejeto !== null">
                    <b>
                      Sprejeto:
                    </b>
                    {{ pravica.sprejeto }}
                  </span>
                  <span v-else-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Velja od:
                    </b>
                    {{ pravica.datumOd }}
                  </span>
                  <span v-else-if="typeof pravica.poslano !== 'undefined' && pravica.poslano !== null">
                    <b>
                      Poslano:
                    </b>
                    {{ pravica.poslano }}
                  </span>
                  <span v-else-if="typeof pravica.poteceno !== 'undefined' && pravica.poteceno !== null">
                    <b>
                      Potečeno:
                    </b>
                    {{ pravica.poteceno }}
                  </span>
                  <span>
                    <b>
                      Status:
                    </b>
                    Preklicano
                  </span>
                  <div style="padding: 0 0 20px 0;">
                    <a style="cursor: pointer; color: #111820" @click="PreklicDodeljenePravice(pravica.id)">
                      Odstrani
                      <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                    </a>
                  </div>
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="dodeljenePraviceNeaktivne.length > 0">
        <div style="padding-top: 50px; padding-bottom: 20px">
          <div>
            <p class="open-sans-20pt">
              Seznam neaktivnih pravic
            </p>
          </div>
        </div>
        <div v-if="prikazTabele === '1'">
          <el-table :data="dodeljenePraviceNeaktivne">
            <el-table-column
              min-width="100px"
              prop="ime"
              label="Uporabnik">
              <template slot-scope="scope">
                <div v-for="pravica in scope.row">
                  {{ pravica.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              min-width="120px"
              prop="ime"
              label="Dodeljena pravica">
              <template slot-scope="scope">
                <div v-for="nazivPravice in scope.row.dovoljenja">
                  {{ nazivPravice.naziv }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Nabor pravice">
              <template slot-scope="scope">
                <div v-for="naborPravice in scope.row.dovoljenja">
                  {{ naborPravice.scope }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Dodeljena">
              <template slot-scope="scope">
                <div v-for="veljaOd in scope.row.dovoljenja">
                  {{ veljaOd.datumOd }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Velja do">
              <template slot-scope="scope">
                <div v-for="veljaDo in scope.row.dovoljenja">
                  <span v-if="veljaDo.datumDo === '01.01.2300 00:00:00'">
                    Do preklica
                  </span>
                  <span v-else>
                    {{ veljaDo.datumDo }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Status">
              <template slot-scope="scope">
                <div v-for="status in scope.row.dovoljenja">
                  Preklicano
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="20px">
              <template slot-scope="scope">
                <div/>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table
            :current-page='2' :page-size='1'
            :row-key="row => row.index"
            :data="dodeljenePraviceNeaktivne">
            <el-table-column>
              <template slot-scope="props">
                <div style="padding: 20px 0" class="open-sans-17pt" v-if="typeof props.row.uporabnik !== 'undefined'">
                  <div v-if="props.row.uporabnik.ime !== undefined">
                    <span>
                        <b>
                          Uporabnik:
                        </b>
                      </span>
                    {{ props.row.uporabnik.ime }}
                  </div>
                  <div>
                    <span>
                        <b>
                          Email:
                        </b>
                      </span>
                    {{ props.row.uporabnik.email }}
                  </div>
                </div>
                <p v-for="pravica in props.row.dovoljenja" class="mobile-cell">
                  <span>
                    <b>
                      Deljena pravica:
                    </b>
                    {{ pravica.naziv }}
                  </span>
                  <span>
                    <b>
                      Nabor pravice:
                    </b>
                    {{ pravica.scope }}
                  </span>
                  <span v-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Dodeljena:
                    </b>
                    {{ pravica.scope }}
                  </span>
                  <span v-else-if="typeof pravica.sprejeto !== 'undefined' && pravica.sprejeto !== null">
                    <b>
                      Sprejeto:
                    </b>
                    {{ pravica.sprejeto }}
                  </span>
                  <span v-else-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Velja od:
                    </b>
                    {{ pravica.datumOd }}
                  </span>
                  <span v-else-if="typeof pravica.poslano !== 'undefined' && pravica.poslano !== null">
                    <b>
                      Poslano:
                    </b>
                    {{ pravica.poslano }}
                  </span>
                  <span v-else-if="typeof pravica.poteceno !== 'undefined' && pravica.poteceno !== null">
                    <b>
                      Potečeno:
                    </b>
                    {{ pravica.poteceno }}
                  </span>
                  <span>
                    <b>
                      Status:
                    </b>
                    Preklicano
                  </span>
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="odmik-zgoraj-dodeljene-pravice" v-else>
      <div class="postavitev-slike">
        <img src="/static/img/Pravice/Icon-ni-dodeljenih-pravic.png">
      </div>
      <div class="postavitev-vsebine">
        <p class="navadno-besedilo">
          Povabite svoje družinske člane k skupnemu upravljanju vaše T-2 naročnine.
        </p>
        <div v-if="HasPermission('PRIKLJUCKI', true)">
          <div class="odmik-dodajanje-predala">
            <el-button type="primary" class="gumb-potrdi" @click="$emit('dodeliPravico')">
              DODELITE PRAVICO
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  Button,
  Option,
  Select,
  Radio,
  Form,
  FormItem,
  Input,
  Table,
  TableColumn,
  Collapse,
  CollapseItem,
  Divider,
  MessageBox
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'
import {VseDeljenePravice} from 'src/assets/js/globalne_funkcije/Pravice/VseDeljenePravice.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {SirinaOkna} from '../../../../../assets/js/globalne_funkcije/SirinaOkna'
import Vue from 'vue'
export default {
  name: 'DodeljenePravice',
  mixins: [VseDeljenePravice, SirinaOkna],
  data () {
    return {
      dodeljeneAktivnePravice: [],
      nalaganjePridobljenihPravic: true,
      dodeljenePraviceVpostopku: [],
      povezavaT2Net: null,
      steviloDeljenihPravic: 0,
      mejnaSirinaTabela: 1440,
      prikazTabele: '1',
      formaOrientacija: 'left',
      mejnaSirina: 360,
      expandRowKeysCakanje: [],
      dodeljenePraviceNeaktivne: [],
      povezavaUrlMojt2: ''
    }
  },
  components: {
    'VseDeljenePravice': VseDeljenePravice,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [FormItem.name]: FormItem,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetDeljenePravice()
    this.povezavaT2Net = povezave.BASE_URL_T2_STRAN
    this.povezavaUrlMojt2 = povezave.BASE_URL_MOJ_T_2
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    IzbiraVrsticeZaSeznamPravicCakanje (row) {
      const idindex = row.index
      const lastIdIndex = this.expandRowKeysCakanje[0]
      this.expandRowKeysCakanje = idindex === lastIdIndex ? [] : [idindex]
    },
    VseDeljenePravicePrenos (prenosniPodatki, nalaganje) {
      this.dodeljenePraviceVpostopku = []
      this.dodeljeneAktivnePravice = []
      this.dodeljenePraviceNeaktivne = []
      for (let i = 0; i < prenosniPodatki.data.active.length; i++) {
        Vue.set(prenosniPodatki.data.active[i], 'index', i)
        this.dodeljeneAktivnePravice.push(prenosniPodatki.data.active[i])
      }
      for (let i = 0; i < prenosniPodatki.data.pending.length; i++) {
        Vue.set(prenosniPodatki.data.pending[i], 'index', i)
        this.dodeljenePraviceVpostopku.push(prenosniPodatki.data.pending[i])
      }
      if (typeof prenosniPodatki.data.inactive !== 'undefined') {
        for (let i = 0; i < prenosniPodatki.data.inactive.length; i++) {
          Vue.set(prenosniPodatki.data.inactive[i], 'index', i)
          let permissionsArray = []
          for (let j = 0; j < prenosniPodatki.data.inactive[i].dovoljenja.length; j++) {
            if (typeof prenosniPodatki.data.inactive[i].dovoljenja[j].sprejeto !== 'undefined' &&
              prenosniPodatki.data.inactive[i].dovoljenja[j].sprejeto !== null) {
              continue
            }
            if (typeof prenosniPodatki.data.inactive[i].dovoljenja[j].poslano !== 'undefined') {
              Vue.set(prenosniPodatki.data.inactive[i].dovoljenja[j], 'datumOd', prenosniPodatki.data.inactive[i].dovoljenja[j].poslano)
            }
            if (typeof prenosniPodatki.data.inactive[i].dovoljenja[j].poteceno !== 'undefined') {
              Vue.set(prenosniPodatki.data.inactive[i].dovoljenja[j], 'datumDo', prenosniPodatki.data.inactive[i].dovoljenja[j].poteceno)
            }
            permissionsArray.push(prenosniPodatki.data.inactive[i].dovoljenja[j])
          }
          if (permissionsArray.length > 0) {
            let permission = prenosniPodatki.data.inactive[i]
            permission.dovoljenja = permissionsArray
            this.dodeljenePraviceNeaktivne.push(permission)
          }
        }
      }
      this.nalaganjePridobljenihPravic = nalaganje
    },
    PreklicPoslanegaPovabila (idPermissionGrantRequest) {
      let param = ['id=' + idPermissionGrantRequest]
      this.clientAgent.postWsRequest(
        this,
        'permissions/witdhrawPermissionGrantRequest?',
        param,
        null,
        'SetPreklicPoslanegaPovabila',
        'ErrPreklicPoslanegaPovabila')
    },
    SetPreklicPoslanegaPovabila () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno preklican poslan zahtevek.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetDeljenePravice()
    },
    ErrPreklicPoslanegaPovabila (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PreklicDodeljenePravice (idPermission) {
      MessageBox.confirm(
        'Ali ste prepričani, da želite preklicati dodeljeno pravico?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['id=' + idPermission]
        this.clientAgent.postWsRequest(this,
          'permissions/withdrawPermission?',
          param,
          null,
          'GetPreklicDodeljenePravice',
          'ErrPreklicDodeljenePravice')
      }).catch((err) => {
        err = null
      })
    },
    GetPreklicDodeljenePravice () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno preklicana pravica.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetDeljenePravice()
    },
    ErrPreklicDodeljenePravice (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/Email/KomponentaBrezPredalov.css"/>
<style scoped>
table, th, td {
  border-collapse: collapse;
}

th, td {
  padding: 5px;
}

th {
  text-align: left;
}

.samostojna-vrstica{
  display: block;
}

.odmik-dodajanje-predala {
  padding-top: 30px;
}

.odmik-zgoraj-dodeljene-pravice {
  padding-top: 43px;
}

/deep/ .el-form-item__label {
  padding: 0 0 0 0;
}

/deep/ .el-table .el-table__cell {
  vertical-align: baseline;
}

@media only screen and (max-width: 1440px) {
  .mobile-cell span{
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/UporabnikiInPravice/DodeljenePravice.vue